<script setup lang="ts">
import { computed, onMounted, onBeforeUnmount, watch } from 'vue';
import { useRoute } from 'vue-router';
import AppHeader from '@/components/AppHeader.vue';
import { useAuthStore } from '@/stores/auth';
import { useLiveStore } from '@/stores/live';

const route = useRoute();
const auth = useAuthStore();
const live = useLiveStore();

const showChrome = computed(
  () => auth.isAuthenticated && route.meta.chrome !== false,
);

// One socket for the whole application: every view reads from the live store
// rather than opening a connection of its own.
watch(
  () => auth.isAuthenticated,
  (authenticated) => {
    if (authenticated) live.connect();
    else live.disconnect();
  },
  { immediate: true },
);

onMounted(() => {
  if (auth.isAuthenticated) live.connect();
});

onBeforeUnmount(() => live.disconnect());
</script>

<template>
  <div class="shell">
    <AppHeader v-if="showChrome" />
    <main :class="['shell__main', { 'shell__main--bare': !showChrome }]">
      <RouterView v-slot="{ Component }">
        <component :is="Component" />
      </RouterView>
    </main>
  </div>
</template>

<style scoped>
.shell {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--bg-root);
}

.shell__main {
  flex: 1;
  padding: var(--gap);
  min-width: 0;
}

.shell__main--bare { padding: 0; }
</style>
